import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Lenis from 'lenis';
import { Toaster } from './components/ui/sonner';
import { LanguageProvider } from './context/LanguageContext';
import { AuthProvider } from './context/AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import AuthCallback from './components/AuthCallback';
import Home from './pages/Home';
import Selection from './pages/Selection';
import Training from './pages/Training';
import Masterclass from './pages/Masterclass';
import TrainingPayment from './pages/TrainingPayment';
import Account from './pages/Account';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import DCapital from './pages/DCapital';
import SelectionPayment from './pages/SelectionPayment';

function ScrollReset() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function Shell() {
  const location = useLocation();

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <div className="min-h-screen bg-[#0F172A] text-slate-100">
      <ScrollReset />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/selection" element={<Selection />} />
        <Route path="/training" element={<Training />} />
        <Route path="/masterclass" element={<Masterclass />} />
        <Route path="/3daymc" element={<Masterclass />} />
        <Route path="/dcapital" element={<DCapital />} />
        <Route path="/training-payment" element={<TrainingPayment />} />
        <Route path="/selection-payment" element={<SelectionPayment />} />
        <Route path="/account" element={<Account />} />
        <Route path="/payment/success" element={<PaymentSuccess />} />
        <Route path="/payment/cancel" element={<PaymentCancel />} />
      </Routes>
      <Footer />
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <Shell />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
